import { useQuery } from "react-query";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";

export type HeaderNavItemKind =
  | "custom"
  | "home"
  | "members"
  | "events"
  | "courses"
  | "leaderboard";

export type HeaderNavItemVisibility = "enabled" | "disabled" | "admin_only";
export type HeaderNavItemAudience = "logged_in" | "logged_out" | "everyone";
export type HeaderNavAudienceApiParam = "logged_in" | "logged_out";

const HEADER_NAV_ITEMS_CACHE_TIME = 24 * 60 * 60 * 1000;
const HEADER_NAV_ITEMS_STALE_TIME = 12 * 60 * 60 * 1000;

export interface HeaderNavItem {
  audience: HeaderNavItemAudience;
  community_id: number;
  id: number;
  kind: HeaderNavItemKind;
  name: string;
  open_in_new_window: boolean;
  url: string | null;
  visibility: HeaderNavItemVisibility;
}

export interface UseFetchHeaderNavItemsProps {
  audience?: HeaderNavAudienceApiParam;
  id?: number | string;
}

export const useFetchHeaderNavItems = ({
  id,
  audience,
}: UseFetchHeaderNavItemsProps) =>
  useQuery<HeaderNavItem[], Error>(
    ["community", "header-nav-items", audience],
    () =>
      reactQueryGet(
        internalApi.settings.navigation.list(
          audience ? { params: { audience } } : {},
        ),
      ),
    {
      enabled: !!id,
      staleTime: HEADER_NAV_ITEMS_STALE_TIME,
      cacheTime: HEADER_NAV_ITEMS_CACHE_TIME,
    },
  );
